import { Service } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';
import * as serviceViewNames from '@estee/elc-service-view-names';

import { IServiceAppConfig } from '~domain/entities/IConfig';

import { AccountServiceStartedUseCase } from '~use-cases/AccountServiceStartedUseCase';

import { diContainer, serviceNames } from './diContainer';

const { name, version } = __serviceInfo__;

export class AccountService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);

        this.registerView(
            serviceViewNames.ACCOUNT_SIDEBAR,
            () =>
                import(
                    /* webpackChunkName: 'AccountSidebar' */
                    '../exported/account-sidebar/AccountSidebar'
                ),
            () => diContainer.get(serviceNames.accountSidebarViewController)
        );
    }

    public async start(appConfig: IServiceAppConfig) {
        const service = await super.start(appConfig);
        const requestedBuidConfigs = ['language'];

        const useCase = new AccountServiceStartedUseCase({
            appConfig,
            requestedBuidConfigs
        });

        await useCase.execute();

        return service;
    }
}
